export default "__VITE_ASSET__CLPAhtZI__"